import React from "react";
import PropTypes from "prop-types";
import gql from "graphql-tag";
import { useMutation } from "@apollo/client";

import { Form } from "react-final-form";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

import CreatePolicyForm from "../components/CreatePolicyForm";

// FIXME checkout https://mui.com/components/use-media-query/#using-material-uis-breakpoint-helpers
const withMobileDialog = () => (WrappedComponent) => (props) =>
  <WrappedComponent {...props} width="lg" fullScreen={false} />;

const CREATE_POLICY = gql`
  mutation CreatePolicy($input: CreatePolicyInput!) {
    policies {
      create(input: $input) {
        policy {
          id
          number
          insurerName
          fileClaimSubmissionEmail
        }
      }
    }
  }
`;

const POLICY_QUERY = gql`
  {
    policies {
      all {
        totalCount
        edges {
          cursor
          node {
            id
            number
            insurerName
            fileClaimSubmissionEmail
          }
        }
      }
    }
  }
`;

const CreatePolicyDialog = ({ open, fullScreen, handleClose }) => {
  const [create, { loading: submitting }] = useMutation(CREATE_POLICY, {
    refetchQueries: () => [
      {
        query: POLICY_QUERY,
      },
    ],
  });

  const handleFormSubmit = (form) => {
    const variables = { input: form };

    create({ variables }).then(() => handleClose());
  };

  return (
    <Dialog
      open={open}
      fullScreen={fullScreen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <Form
        onSubmit={handleFormSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <DialogTitle id="form-dialog-title">Add policy</DialogTitle>
            <DialogContent>
              <CreatePolicyForm />
            </DialogContent>
            <DialogActions>
              <Button
                disabled={submitting}
                onClick={handleClose}
                color="primary"
              >
                Cancel
              </Button>
              <Button disabled={submitting} type="submit" color="primary">
                Save
              </Button>
            </DialogActions>
          </form>
        )}
      />
    </Dialog>
  );
};

CreatePolicyDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default withMobileDialog()(CreatePolicyDialog);
